export default {
  'get-list': {
    method: 'post',
    url: '/order/list'
  },
  add: {
    method: 'post',
    url: '/order'
  },
  delete: {
    method: 'delete',
    url: '/order'
  },
  update: {
    method: 'put',
    url: '/order/ID'
  },
  updatePatch: {
    method: 'patch',
    url: '/order/ID'
  },
  detail: {
    method: 'get',
    url: '/order/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/order/status'
  },
  select: {
    method: 'get',
    url: '/order/find?key=KEY'
  },
  'calculate-shipping-plan': {
    method: 'post',
    url: '/order/calculate-shipping-plan'
  },
  'calculate-shipping-plan-manual': {
    method: 'post',
    url: '/order/calculate-shipping-plan-manual'
  },
  'create-teamplate-shipping-plan': {
    method: 'post',
    url: '/order/create-teamplate-shipping-plan'
  },
  'quote-by-customer-request': {
    method: 'post',
    url: '/order/quote-by-customer-request'
  },
  'add-by-request': {
    method: 'post',
    url: '/order/add-by-request'
  },
  'add-document': {
    method: 'POST',
    url: '/order/document/upload'
  },
  'delete-document': {
    url: '/order/document/delete',
    method: 'DELETE'
  },
  'edit-document': {
    url: 'order/document/file/ID',
    method: 'PUT'
  },
  archive: {
    method: 'delete',
    url: '/order/archive'
  },
  restore: {
    method: 'put',
    url: '/order/restore'
  },
  searchQuote: {
    method: 'get',
    url: '/order/search-quote/ID'
  },
  addQuoteToOrder: {
    method: 'post',
    url: '/order/add-quote/ID'
  },
  editQuoteToOrder: {
    method: 'put',
    url: '/order/edit-quote/ID'
  },
  cancel: {
    method: 'put',
    url: '/order/ID/cancel'
  },
  addContainerNumbers: {
    method: 'post',
    url: '/order/ID/container-number'
  },
  getContainerNumbers: {
    method: 'get',
    url: '/order/ID/container-number'
  },
  addContainerNumber: {
    method: 'post',
    url: '/order/ID/container-one-number'
  },
  syncCrm: {
    method: 'post',
    url: '/order/ID/sync-crm'
  }
}
